module.exports = __webpack_public_path__ + "static/8011365485db2f04b9001c-4fdc7978bef1ba0cb6886f79ff12cc26.jpg";